import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { MechanismReveal } from './components/MechanismReveal';
import { OldSolutionsFail } from './components/OldSolutionsFail';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { WhatsInside } from './components/WhatsInside';
import { FuturePacing } from './components/FuturePacing';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#0F1B2D] font-sans selection:bg-[#E8722A] selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <MechanismReveal data-id="element-3" />
      <OldSolutionsFail data-id="element-4" />
      <WhoIsThisFor data-id="element-5" />
      <WhatsInside data-id="element-6" />
      <FuturePacing data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}